import i18n from 'i18next';
import {initReactI18next} from 'react-i18next';
import en from '../lang/en.json';
import kz from '../lang/kz.json';
import ru from '../lang/ru.json';
import {getStore} from "./functions";

const resources = {
    en: {
        translation: en,
    },
    kz: {
        translation: kz,
    },
    ru: {
        translation: ru,
    }
};
i18n.use(initReactI18next).init({
    resources,
    lng: 'en',
    fallbackLng: 'en',
    compatibilityJSON: 'v3',
    interpolation: {
        escapeValue: false
    }
}).then(r => {
    getStore('@wtitl.lang').then(lang => {
        i18n.changeLanguage(lang).then(r => {})
    });
});
